<template>
  <tr data-test="genericRow">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <td><slot name="selection" /></td>
      <td>
        {{ product.name }}
        <div v-if="item.paymentInProcess" class="secondary--text">
          {{
            $t(
              "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
              "In process",
              "Label of the order table section"
            )
          }}
        </div>
      </td>
      <td>
        <AppShowInputSkeleton
          v-if="item.payable.productParams"
          order-preset="productParams"
          :params="item.payable.productParams"
        />
        <AppShowEntryDetailsLine
          v-if="product.relatedEntities.includes('Entry') && item.entry"
          :entry="item.entry"
        />

        <AppShowHorseName
          v-if="product.relatedEntities.includes('Horse') && item.horse"
          :horse="item.horse"
          show-identifier
        />

        <slot name="notAllowedReasons" />
      </td>
      <td v-if="showPaymentDeadline" style="width: 25%">
        {{ item.paymentDeadline ? $dayjs.date(item.paymentDeadline) : "" }}
      </td>
      <td class="text-right"><slot name="price" /></td>
      <td><slot name="actions" /></td>
    </template>
    <template v-else>
      <td style="font-size: 12px" colspan="99">
        <v-row dense class="align-center">
          <v-col cols="1" class="mr-3">
            <slot name="selection" />
          </v-col>
          <v-col>
            <div>
              {{ product.name }}
            </div>
            <div v-if="item.paymentInProcess" class="secondary--text">
              {{
                $t(
                  "people:ShoppingBasket.ShoppingBasketTab.InProcess.text",
                  "In process",
                  "Label of the order table section"
                )
              }}
            </div>

            <AppShowEntryDetailsLine
              v-if="product.relatedEntities.includes('Entry') && item.entry"
              :entry="item.entry"
            />

            <AppShowHorseName
              v-if="product.relatedEntities.includes('Horse') && item.horse"
              show-identifier
            />

            <AppShowInputSkeleton
              v-if="item.payable.productParams"
              order-preset="productParams"
              :params="item.payable.productParams"
            />
            <slot name="notAllowedReasons" />
          </v-col>
          <div v-if="item.paymentDeadline" class="secondary--text">
            <b>{{
              $t(
                "people:ShoppingBasket.ShoppingBasketTab.Deadline.label",
                "Deadline",
                "Label of the order table section"
              )
            }}</b>
            &nbsp;
            {{ $dayjs.date(item.paymentDeadline) }}
          </div>
          <div class="text-right">
            <slot name="price" />
          </div>
        </v-row>
        <div class="pa-1 mt-2 d-flex justify-end">
          <slot
            name="actions"
            :button-props="{
              small: false,
              xSmall: true
            }"
          />
        </div>
      </td>
    </template>
  </tr>
</template>
<script>
import gql from "fraql";
import AppShowInputSkeleton from "@AppShows/AppShowInputSkeleton.vue";
import AppShowEntryDetailsLine from "@AppShows/event/AppShowEntryDetailsLine.vue";
import AppShowHorseName from "@AppShows/horse/AppShowHorseName.vue";

export default {
  name: "GenericProductOrderDetails",
  components: {
    AppShowInputSkeleton,
    AppShowEntryDetailsLine,
    AppShowHorseName
  },
  inheritAttrs: false,
  props: {
    item: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    },
    showPaymentDeadline: {
      type: Boolean,
      default: false
    }
  },
  fragments: {
    payableFields: gql`
      fragment _ on Payable {
        productId
        product {
          id
          name
          relatedEntities
        }
        horse {
          id
          ${AppShowHorseName.fragments.horse}
        }
      }
    `,
    entryFields: AppShowEntryDetailsLine.fragments.entryFields
  }
};
</script>
